import React from "react";
import { HelmetProvider } from "react-helmet-async";
import MainRouter from "./routes/MainRouter";
import AdminInterestState from "./context/adminInterest/AdminInterestState";
import AdminRegistrationState from "./context/adminRegistration/AdminRegistrationState";
import AuthState from "./context/auth/AuthState";
import InterestState from "./context/interest/InterestState";
import RegistrationState from "./context/registration/RegistrationState";
import UserState from "./context/users/UserState";
import LeloState from "./context/leloreg/leloState";
import AdminLeloState from "./context/adminLelo/AdminLeloState";

import AdminemailLogsState from "./context/adminemailLogs/AdminemailLogsState";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  return (
    <HelmetProvider>
      <AuthState>
        <UserState>
          <RegistrationState>
            <InterestState>
              <AdminRegistrationState>
                <AdminInterestState>
                  <LeloState>
                    <AdminLeloState>
                      <AdminemailLogsState>
                        <MainRouter />
                        <ToastContainer />
                      </AdminemailLogsState>
                    </AdminLeloState>
                  </LeloState>
                </AdminInterestState>
              </AdminRegistrationState>
            </InterestState>
          </RegistrationState>
        </UserState>
      </AuthState>
    </HelmetProvider>
  );
};

export default App;
